import React, { useEffect } from 'react';
import Modal from './Modal';
import useUiStore from '../store/uiStore';

const shortcuts = [
  { keys: 'Ctrl/Cmd + K', description: 'باز کردن جست‌وجوی سراسری / command palette' },
  { keys: '/', description: 'تمرکز روی جست‌وجوی سراسری در زمانی که در فیلد متنی نیستی' },
  { keys: 'Shift + A', description: 'باز کردن پنل اقدام سریع' },
  { keys: 'Shift + B', description: 'فعال یا غیرفعال کردن حالت batch mode' },
  { keys: 'g سپس c', description: 'رفتن به همه دام‌ها' },
  { keys: 'g سپس r', description: 'رفتن به داشبورد باروری' },
  { keys: 'g سپس h', description: 'رفتن به سلامت / درمان' },
  { keys: 'Shift + /', description: 'نمایش همین راهنمای میان‌برها' },
  { keys: 'Esc', description: 'بستن پنجره‌های سریع' },
];

function KeyboardShortcutsHelp() {
  const shortcutHelpOpen = useUiStore((state) => state.shortcutHelpOpen);
  const setShortcutHelpOpen = useUiStore((state) => state.setShortcutHelpOpen);

  useEffect(() => {
    const onKeyDown = (event) => {
      const targetTag = event.target?.tagName;
      const isInputLike = ['INPUT', 'TEXTAREA', 'SELECT'].includes(targetTag) || event.target?.isContentEditable;
      if (!isInputLike && event.key === '?' ) {
        event.preventDefault();
        setShortcutHelpOpen(true);
      }
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [setShortcutHelpOpen]);

  return (
    <Modal isOpen={shortcutHelpOpen} onClose={() => setShortcutHelpOpen(false)} title="میان‌برهای صفحه‌کلید" size="lg">
      <div className="space-y-3">
        {shortcuts.map((item) => (
          <div key={item.keys} className="flex items-start justify-between gap-4 rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3">
            <div className="text-sm leading-7 text-slate-600">{item.description}</div>
            <kbd className="rounded-lg border border-slate-300 bg-white px-3 py-1 text-xs font-semibold text-slate-700 whitespace-nowrap">{item.keys}</kbd>
          </div>
        ))}
      </div>
    </Modal>
  );
}

export default KeyboardShortcutsHelp;
